import { createRouterInstance } from './routes.js';

// 修改1: 导出 isReloading 状态，让 main.js 可以访问
export let isReloading = false;  // 改为 export

// 初始路由实例（无用户角色）
const router = createRouterInstance();

// 当前路由实例
let currentRouter = router;

/**
 * 重新加载路由（根据用户角色）
 * @param {string} userRole - 用户角色
 */
export function reloadRoutes(userRole = null) {
  // 修改2: 删除重复的 console.log
  if (isReloading) {
    console.log('⚠️ Already reloading, skipping...');
    return true;
  }
  console.log('🔄 reloadRoutes STARTED for role:', userRole);
  isReloading = true;

  try {
    // 1. 创建新的路由实例
    console.log('📝 Step 1: Creating new router instance...');
    const newRouter = createRouterInstance(userRole);

    // 2. 检查新路由实例
    const newRoutes = newRouter.getRoutes();
    console.log('📊 New router routes count:', newRoutes.length);

    const currentPath = window.location.pathname;
    console.log('📍 Current path:', currentPath);

    const liveBigScreenInNewRouter = newRoutes.some(r =>
      r.path === '/live-big-screen' || r.name === 'LiveBigScreen'
    );
    console.log('🔍 LiveBigScreen in new router?', liveBigScreenInNewRouter);

    // 3. 记录是否正在访问 live-big-screen
    const isNavigatingToLiveBigScreen = currentPath === '/live-big-screen';

    // 4. 替换 matcher
    console.log('🔄 Step 3: Attempting to replace matcher...');
    try {
      const oldMatcher = router.matcher;
      router.matcher = newRouter.matcher;
      console.log('✅ Matcher replaced successfully');

      // 5. 验证替换
      console.log('🔍 Step 4: Verifying replacement...');
      const currentRoutes = router.getRoutes();

      const liveBigScreenInCurrent = currentRoutes.some(r =>
        r.path === '/live-big-screen' || r.name === 'LiveBigScreen'
      );
      console.log('🎯 LiveBigScreen in current router?', liveBigScreenInCurrent);

      if (liveBigScreenInCurrent) {
        console.log('🎉🎉🎉 SUCCESS: LiveBigScreen route is now in current router!');

        const currentPath = window.location.pathname;
        if (currentPath === '/live-big-screen') {
          console.log('🔄 Re-triggering navigation to live-big-screen');

          // 修改3: 使用全局变量通知 main.js 这是重载后的导航
          if (typeof window !== 'undefined') {
            window.__IS_NAVIGATING_AFTER_RELOAD = true;
          }

          // 使用 setTimeout 确保不在同一个调用栈中
          setTimeout(() => {
            router.replace('/live-big-screen').catch(err => {
              if (err.name !== 'NavigationDuplicated') {
                console.error('Navigation error:', err);
              }
            }).finally(() => {
              // 重设标志
              isReloading = false;
              if (typeof window !== 'undefined') {
                window.__IS_NAVIGATING_AFTER_RELOAD = false;
              }
            });
          }, 0);
        } else {
          isReloading = false;
        }

        return true;
      } else {
        console.log('❌ LiveBigScreen not found in current router after replacement');
        router.matcher = oldMatcher;
        return alternativeRouteReload(userRole, isNavigatingToLiveBigScreen);
      }

    } catch (matcherError) {
      console.error('💥 Error replacing matcher:', matcherError);
      return alternativeRouteReload(userRole, currentPath === '/live-big-screen');
    }

  } catch (error) {
    console.error('💥💥💥 FATAL ERROR:', error);
    isReloading = false;
    return false;
  }
}

/**
 * 获取导航配置
 * @returns {Object} 导航配置
 */
export function getNavigationConfig() {
  return {
    // 可以在这里添加一些全局导航配置
    categories: {
      show: true,
      name: 'Categories'
    }
  };
}

function alternativeRouteReload(userRole, shouldRetryNavigation = false) {
  console.log('⚡ Starting alternative route reload...');

  try {
    const newRouter = createRouterInstance(userRole);
    const newRoutes = newRouter.getRoutes();

    console.log('📊 Adding', newRoutes.length, 'routes...');

    // 先移除所有现有路由（除了404）
    const currentRoutes = router.getRoutes();
    currentRoutes.forEach(route => {
      if (route.name && route.name !== 'NotFound') {
        router.removeRoute(route.name);
      }
    });

    // 添加新路由
    newRoutes.forEach(route => {
      if (route.name) {
        router.addRoute(route);
      }
    });

    console.log('✅ Alternative reload completed');

    // 验证
    const finalRoutes = router.getRoutes();
    const hasLiveBigScreen = finalRoutes.some(r =>
      r.path === '/live-big-screen' || r.name === 'LiveBigScreen'
    );

    console.log('🎯 LiveBigScreen after alternative reload?', hasLiveBigScreen);

    // 🚀 关键修复：如果需要重试导航
    if (shouldRetryNavigation && hasLiveBigScreen) {
      console.log('🔄 Re-triggering navigation after alternative reload');

      // 修改4: 同样设置全局标志
      if (typeof window !== 'undefined') {
        window.__IS_NAVIGATING_AFTER_RELOAD = true;
      }

      setTimeout(() => {
        router.replace('/live-big-screen').catch(() => { }).finally(() => {
          if (typeof window !== 'undefined') {
            window.__IS_NAVIGATING_AFTER_RELOAD = false;
          }
        });
      }, 0);
    }

    return hasLiveBigScreen;

  } catch (error) {
    console.error('💥 Alternative reload failed:', error);
    return false;
  }
}

export default router;